export const ERROR_UNAUTHORIZED = "unauthorized";
